import React, { useState, useEffect } from 'react';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { heroSlides } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import HutRiWatermark from '../HutRiWatermark';

const HeroCarousel = () => {
  const [idx, setIdx] = useState(0);
  const { tv } = useLang();

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroSlides.length), 7000);
    return () => clearInterval(t);
  }, []);

  const slide = heroSlides[idx];

  return (
    <section className="relative bg-[#0a1929] overflow-hidden" style={{ height: 'calc(100vh - 180px)', minHeight: 560 }}>
      {heroSlides.map((s, i) => (
        <div key={s.id} className={`absolute inset-0 transition-opacity duration-1000 ${i === idx ? 'opacity-100' : 'opacity-0'}`} style={{ background: s.imageBg || '#0a1929' }}>
          <img src={s.image} alt={tv(s.title)} className="w-full h-full" style={{ objectFit: s.imageFit || 'cover', objectPosition: s.imagePosition || 'center', transform: i === idx ? 'scale(1.05)' : 'scale(1)', transition: 'transform 8s ease-out' }} />
          <div className="absolute inset-0 navy-gradient-overlay" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1929]/85 via-[#0a1929]/40 to-transparent" />
        </div>
      ))}

      {/* HUT RI 81 logo watermark - appears over all slides */}
      <HutRiWatermark size="lg" />

      <div className="relative h-full max-w-7xl mx-auto px-4 flex items-center">
        <div key={idx} className="max-w-2xl animate-fade-up">
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-10 h-[2px] bg-[#d4a017]" />
            <span className="text-[#d4a017] text-sm font-bold tracking-[0.25em] uppercase">{tv(slide.eyebrow)}</span>
          </div>
          <h1 className="text-white text-5xl md:text-7xl font-bold leading-[1.05] mb-6" style={{ fontFamily: "'Roboto Condensed', sans-serif" }}>
            {tv(slide.title)}
          </h1>
          <p className="text-white/85 text-lg leading-relaxed mb-8 max-w-xl">{tv(slide.subtitle)}</p>
          <Link to={slide.cta.href} className="inline-flex items-center gap-2 bg-[#d4a017] hover:bg-[#b8860b] text-[#0a1929] font-bold px-7 py-3.5 tracking-wide uppercase text-sm transition group">
            {tv(slide.cta.label)}
            <ArrowRight size={18} className="group-hover:translate-x-1 transition" />
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 right-4 md:right-8 z-10 flex items-center gap-3">
        <button onClick={() => setIdx((i) => (i - 1 + heroSlides.length) % heroSlides.length)} className="w-11 h-11 grid place-items-center bg-white/10 hover:bg-[#d4a017] hover:text-[#0a1929] text-white border border-white/30 backdrop-blur transition">
          <ChevronLeft size={20} />
        </button>
        <div className="text-white font-mono text-sm tracking-wider bg-black/40 border border-white/20 px-3 py-2">
          <span className="text-[#d4a017] font-bold">0{idx + 1}</span>
          <span className="text-white/50 mx-2">/</span>
          <span>0{heroSlides.length}</span>
        </div>
        <button onClick={() => setIdx((i) => (i + 1) % heroSlides.length)} className="w-11 h-11 grid place-items-center bg-white/10 hover:bg-[#d4a017] hover:text-[#0a1929] text-white border border-white/30 backdrop-blur transition">
          <ChevronRight size={20} />
        </button>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#d4a017] to-transparent z-10" />
    </section>
  );
};

export default HeroCarousel;
